import { createSelector } from 'reselect'
import { State } from 'index'

const storeDeliverySettingSelector = (state: State) => state.storeDeliverySetting

export const getStoreDeliverySettings = createSelector(
  [storeDeliverySettingSelector],
  (state) => state.storeDeliverySettings
)
